export class Capability
{
    public get endpoint(): string { return this._endpoint; }
    public get name(): string { return this._name; }

    constructor(private _endpoint: string, private _name: string) { }

    public toString()
    {
        return JSON.stringify(this);
    }
}
